import React from "react";
import "../../../../css/Common/Components/Cards/CardProduct.css";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

/**
 * CardProduct component renders a clickable card with an optional icon and title.
 * Navigates to the provided link when clicked, and applies styling based on state and props.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {React.ComponentType} props.Icon - Optional icon component to display in the card.
 * @param {string} props.title - Title text to display in the card.
 * @param {string} [props.link=""] - URL or route to navigate to when the card is clicked.
 * @param {boolean} [props.isAdviser=false] - If true, applies Adviser-specific styling.
 * @returns {JSX.Element} The rendered CardProduct component.
 */
const CardProduct = ({ Icon, title, link = "", isAdviser = false }) => {
  const [clicked, setClicked] = useState(false);
  const navigate = useNavigate();
 

  return (
    <>
      <button
        className={`Card-Product ${isAdviser ? "Adviser" : ""}  ${
          clicked ? "clicked" : ""
        }`}
        onClick={() => {
          setClicked(!clicked);
          navigate(link);
        }}
      >
        {/* <NewsIcon /> */}

        {Icon && <Icon />}
        <h3>{title}</h3>
      </button>
    </>
  );
};

export default CardProduct;
